.summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-5);
  text-align: center;
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-xl);
}

.score {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-4xl);
  font-weight: 700;
}

.breakdown {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  margin: 0;
  width: 100%;
  max-width: 320px;
}

.row {
  display: flex;
  justify-content: space-between;
}

.rowLabel,
.rowValue {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
}

.footer {
  margin: 0;
  max-width: 420px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}
